import { Grid } from '@mui/material';
import { Patient } from '../../../../../domain/entities';
import CustomDatePicker from '../../../../components/UI/CustomDatePicker/CustomDatePicker';
import { CustomTextField } from '../../../../components/UI/CustomTextField/CustomTextField';

interface Props {
  isValid: boolean;
  patient: Patient;
  onPatientChanged: (patient: Patient) => void;
  onFormUpdated: (isValid: boolean) => void;
}

export const PatientForm = ({ patient, onPatientChanged }: Props) => {
  const setName = (name: string) => onPatientChanged({ ...patient, name });
  const setSSN = (ssn: string) => onPatientChanged({ ...patient, ssn });
  const setPhone = (phone: string) => onPatientChanged({ ...patient, phone });
  const setBirthDate = (birthDate: Date | null | undefined) => {
    if (!birthDate || birthDate === null) return;
    onPatientChanged({ ...patient, birthDate });
  };
  const setGender = (gender: string) => onPatientChanged({ ...patient, gender });
  const setCivilStatus = (civilStatus: string) => onPatientChanged({ ...patient, civilStatus });
  const setAddress = (address: string) => onPatientChanged({ ...patient, address });
  const setState = (state: string) => onPatientChanged({ ...patient, state });
  const setCity = (city: string) => onPatientChanged({ ...patient, city });
  const setEmail = (email: string) => onPatientChanged({ ...patient, email });

  return (
    <Grid container spacing={{ xs: 2, md: 3 }}>
      <Grid item xs={12}>
        <CustomTextField
          id='name'
          label='Nombre'
          value={patient.name}
          onValueChanged={setName}
          ariaLabel='name'
          validations={['required']}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='ssn'
          label='Cédula'
          value={patient.ssn}
          onValueChanged={setSSN}
          ariaLabel='ssn'
          validations={['required', 'length']}
          validationsPayload={{ length: 10 }}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomDatePicker value={patient.birthDate} onChange={setBirthDate} disablePast={false} />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='phone'
          label='Teléfono'
          value={patient.phone}
          onValueChanged={setPhone}
          ariaLabel='phone'
          validations={['required', 'length']}
          validationsPayload={{ length: 10 }}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='email'
          label='Email'
          value={patient.email}
          onValueChanged={setEmail}
          ariaLabel='email'
          validations={['required']}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='civilStatus'
          label='Estado Civil'
          value={patient.civilStatus}
          onValueChanged={setCivilStatus}
          ariaLabel='civilStatus'
          validations={['required']}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='gender'
          label='Género'
          value={patient.gender}
          onValueChanged={setGender}
          ariaLabel='gender'
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='state'
          label='Provincia'
          value={patient.state}
          onValueChanged={setState}
          ariaLabel='state'
          validations={['required']}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTextField
          id='city'
          label='Ciudad'
          value={patient.city}
          onValueChanged={setCity}
          ariaLabel='city'
          validations={['required']}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          id='address'
          label='Dirección'
          value={patient.address}
          onValueChanged={setAddress}
          ariaLabel='address'
          validations={['required']}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
